/**
 * Footer gọn cho web app nội bộ — không dùng pattern website công khai.
 */
import { Box, Typography } from '@mui/material'
import { BRAND_NAME } from './Logo.tsx'

export default function AppFooter() {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        py: 1,
        px: 3,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        © {BRAND_NAME}
      </Typography>
    </Box>
  )
}
